module.exports = __webpack_public_path__ + "static/media/lung-cancer-screening-news.2951b2a4.jpg";